import Input from "../../components/ui/Input";
import Button from "../../components/ui/Button";
import { ReactComponent as Close } from "../../components/ui/styles/Icon_Close.svg";
import { ReactComponent as Plus } from "../../components/ui/styles/plus_icon.svg";
import Modal from "../../components/ui/Modal";
import { useState } from "react";
import { InputBox, ModalCard, ModalCardBody, ModalCardButtons, ModalCardForm, ModalCardHead } from "../domains/AddDomainModal";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { addMailer } from "../../redux/features/PlatformSettingSlice";

const mailerTypes = [{ label: 'SocketLabs', value: 'socketlabs' }, { label: 'ESE', value: 'ese' }];

const AddMailerModal = () => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [mailer, setMailer] = useState('');
    const [alias, setAlias] = useState('');
    const [domain, setDomain] = useState(null);
    const [type, setType] = useState(null);

    const domains = useSelector(state => state.PlatformSetting.domains).filter((d) => d.active).map((d) => { return ({ label: d.domain, value: d._id }) });

    const mailerNameError = mailer.length < 3 || !alias.length || !domain || !type;

    const close = () => setOpen(false);
    const save = () => {
        dispatch(addMailer({ mailer, alias, domain, type }));
        close();
    }

    return (
        <>

            <Button
                className="iconButton"
                onClick={() => setOpen(true)}
            >
                <Plus />
            </Button>
            <Modal show={open} >
                <ModalCard>
                    <ModalCardHead>
                        <h6>Add mailer</h6>
                        <div style={{ cursor: 'pointer', padding: 10 }} onClick={close}>
                            <Close />
                        </div>
                    </ModalCardHead>
                    <ModalCardBody>
                        <ModalCardForm>
                            <InputBox>
                                <label>Mailer</label>
                                <Input
                                    value={mailer}
                                    onChange={(e) => setMailer(e.target.value)}
                                    style={mailer.length !== 0 && mailer.length < 3 ? {
                                        border: '1px solid #C93E3E'
                                    } : {}}
                                    placeholder="Enter mailer name"
                                />
                            </InputBox>
                            <InputBox>
                                <label>Alias</label>
                                <Input
                                    value={alias}
                                    onChange={(e) => setAlias(e.target.value)}
                                    placeholder="Enter alias"
                                />
                            </InputBox>

                            <div style={{
                                gap: '20px',
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                <Select
                                    options={mailerTypes} styles={{
                                        control: (baseStyles) => ({
                                            ...baseStyles,
                                            backgroundColor: '#fff',
                                            borderRadius: '8px',
                                            color: '#4f4f4f',
                                            fontWeight: '',
                                            zIndex: '5000',
                                            cursor: 'pointer'
                                        })
                                    }}
                                    isSearchable={false}
                                    placeholder={'Mailer type'}
                                    onChange={(v) => setType(v.value)}
                                />
                                <Select
                                    options={domains} styles={{
                                        control: (baseStyles) => ({
                                            ...baseStyles,
                                            backgroundColor: '#fff',
                                            borderRadius: '8px',
                                            color: '#4f4f4f',
                                            fontWeight: '',
                                            zIndex: '5000',
                                            cursor: 'pointer'
                                        })
                                    }}
                                    isSearchable={false}
                                    placeholder={'Domain'}
                                    onChange={(v) => setDomain(v.value)}
                                />
                            </div>

                        </ModalCardForm>
                        <ModalCardButtons>
                            <Button onClick={close}>
                                Close
                            </Button>
                            <Button
                                disabled={mailerNameError}
                                id="b-login"
                                onClick={save}
                            >
                                Save
                            </Button>
                        </ModalCardButtons>
                    </ModalCardBody>
                </ModalCard>
            </Modal>


        </>

    )
}

export default AddMailerModal;